import { NgModule, APP_INITIALIZER } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { routes } from './auth.routes';
import { LoginComponent } from './components/login/login.component';
import { LogoutComponent } from './components/logout/logout.component';
import { ResetPasswordComponent } from './components/reset-password/resetPassword.component';
import { ResetPasswordLinkComponent } from './components/reset-password-link/resetPasswordLink.component';
import { SharedModule } from '../shared/shared.module';
import { RecaptchaModule, RECAPTCHA_LANGUAGE } from 'ng-recaptcha';
import { RecaptchaDirective } from './directives/recaptcha.directive';
import { MpsOauth2Service, MpsUserService, mpsFetchBearer } from '../../../mps/mps-auth';

@NgModule({
  declarations: [
    LoginComponent,
    LogoutComponent,
    RecaptchaDirective,
    ResetPasswordComponent,
    ResetPasswordLinkComponent
  ],
  entryComponents: [
    ResetPasswordComponent,
    ResetPasswordLinkComponent
  ],
  providers: [
    RecaptchaDirective,
    {
      provide: RECAPTCHA_LANGUAGE,
      useValue: 'fr', // use French language
    },

    // SSO : charge la liste des fournisseurs et, si l'url porte un `_et`,
    // echange cet identifiant contre le JWT. Ce module est importe par
    // CoreModule, donc charge des le demarrage : l'APP_INITIALIZER s'execute
    // quelle que soit la route sur laquelle l'API renvoie le navigateur.

    MpsOauth2Service,
    {
      provide: APP_INITIALIZER,
      useFactory: mpsFetchBearer,
      multi: true,
      deps: [MpsOauth2Service, MpsUserService]
    },
  ],
  imports: [
    SharedModule,
    RecaptchaModule,
    RouterModule.forChild(routes)
  ],
})
export class AuthModule {

  public constructor() {

  }

}
